<template>
<div class="flex justify-end items-center">
  <div
    class="relative align-left leading-10 mr-2"
    tabindex=0
    @blur="open = false"
  >
    <div
      class="text-left pl-4 pr-10 py-2 text-b2c-grey-600 text-sm
            cursor-pointer w-56 shadow-md rounded-md uppercase"
      :class="{open: open}"
      @click="open = !open"
      v-if="selected"
    >
      {{ selected.name }}
    </div>
    <div
      class="text-b2c-grey-600 rounded-b-md shadow-md text-left w-full
            absolute bg-b2c-grey-100 z-10 text-sm py-2"
      :class="{selectHide: !open}"
    >
      <div
        class="item text-b2c-grey-600 pl-4 cursor-pointer hover:bg-b2c-red-200 py-2 uppercase"
        v-for="(option, i) of options"
        :key="i"
        @click="changeSelected(option)"
      >
        {{ option ? option.name : '' }}
      </div>
    </div>
    <div class="pointer-events-none inset-y-0 absolute
      right-0 flex items-center px-2 pt-1 text-b2c-grey-600">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M9.293 12.95l.707.707L15.657
      8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
    </svg>
  </div>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['options', 'value'],

  data() {
    return {
      open: false,
      selected: '',
      large: this.isLarge ? this.isLarge : false,
      overflow: this.hasOverflow ? this.hasOverflow : false,
    };
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    value() {
      this.selected = this.options.find((option) => {
        if (option && option.value === this.value) {
          return option;
        }
        return '';
      });
    },

    changedLocale() {
      if (!this.selected.value) {
        this.selected = this.options.find((option) => option.value === '');
      }
    },
  },

  mounted() {
    this.selected = this.options.find((option) => {
      if (option && option.value === this.value) {
        return option;
      }
      return '';
    });
  },

  methods: {
    changeSelected(option) {
      this.selected = option;
      this.open = false;
      this.$emit('input', option.value);
    },
  },

};
</script>

<style scoped>

.selectHide {
  display: none;
}
</style>
